import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-details-existing-industry',
  templateUrl: './add-details-existing-industry.component.html',
  styleUrls: ['./add-details-existing-industry.component.css']
})
export class AddDetailsExistingIndustryComponent implements OnInit {

  userData:any = [];

  stationDetails = {};
  deviceDetails = {};
  parameterDetails = {};
  combineDetails = {};

  route = '';

  formErrorUnit = '';
  formErrorStationType = '';
  formErrorDeviceId = '';
  formErrorParameterName = '';
  formErrorStationName = '';
  formErrorStationId = '';
  formErrorStationIdLink = '';
  formErrorDeviceIdLinked = '';
  error = false;

  addDetailLoader = false;

  addType = 'station';
  allStationList = [];
  allDeviceList = [];

  userName = null;
  @Input() industryId: string;


  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
    }

    this.stationDetails['station_type'] = '';

  }

  resetDetails(){
    this.stationDetails = {};
    this.deviceDetails = {};
    this.parameterDetails = {};
    this.formErrorUnit = '';
    this.formErrorStationType = '';
    this.formErrorDeviceId = '';
    this.formErrorParameterName = '';
    this.formErrorStationName = '';
    this.formErrorStationId = '';
    this.formErrorStationIdLink = '';
    this.formErrorDeviceIdLinked = '';
    this.error = false;
    this.addType = 'station';
    this.allStationList = [];
    this.allDeviceList = [];
    this.combineDetails = {};
    this.stationDetails['station_type'] = '';
    this.deviceDetails['station_id'] = '';
  }

  switchView(type){

    this.resetDetails();

    if(type == 'device'){
        this.getStationList();
    }

    if(type == 'parameter'){
      this.getDeviceList();
    }

  }


  getStationList(){
    this.route  = 'get-ind-station-list';
    const token    = localStorage.getItem('userToken');
    this.allStationList = [];
    this.deviceDetails['station_id'] = '';

    let data = {'industry_id':this.industryId};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }

      if(response.status == 200){

        if(response.data.length){
          this.allStationList = response.data;
        }
      }

    });
  }

  getDeviceList(){
    this.route  = 'get-ind-device-list';
    const token    = localStorage.getItem('userToken');
    this.allDeviceList = [];
    this.parameterDetails['device_id'] = '';

    let data = {'industry_id':this.industryId};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }

      if(response.status == 200){

        if(response.data.length){
          this.allDeviceList = response.data;
        }
      }

    });
  }

  validateDetails(){

    this.error = false;

    if(this.addType == 'station'){
      if(this.stationDetails && this.stationDetails['name'] && this.stationDetails['name'].trim() && this.stationDetails['name'].trim() != ' '){
        this.formErrorStationName = '';
      }else{
        this.formErrorStationName = 'Station name is required';
        this.error = true;
      }

      if(this.stationDetails && this.stationDetails['vendor_station_id'] &&this.stationDetails['vendor_station_id'].trim() && this.stationDetails['vendor_station_id'].trim() != ' '){
        this.formErrorStationId = '';
      }else{
        this.formErrorStationId = 'Station id is required';
        this.error = true;
      }

      if(this.stationDetails && this.stationDetails['station_type'] &&this.stationDetails['station_type'].trim() && this.stationDetails['station_type'].trim() != ' '){
        this.formErrorStationType = '';
      }else{
        this.formErrorStationType = 'Station type is required';
        this.error = true;
      }
    }

    if(this.addType == 'station' || this.addType == 'device'){
      if(this.deviceDetails && this.deviceDetails['name'] && this.deviceDetails['name'].trim() && this.deviceDetails['name'].trim() != ' '){
        this.formErrorDeviceId = '';
      }else{
        this.formErrorDeviceId = 'Device id is required';
        this.error = true;
      }

      if(this.addType == 'device'){
        if(this.deviceDetails && this.deviceDetails['station_id'] && this.deviceDetails['station_id'].trim() && this.deviceDetails['station_id'].trim() != ' '){
          this.formErrorStationIdLink = '';
        }else{
          this.formErrorStationIdLink = 'Select station';
          this.error = true;
        }
      }

    }

    if(this.addType == 'station' || this.addType == 'device' || this.addType == 'parameter'){
      if(this.parameterDetails && this.parameterDetails['paramkey'] && this.parameterDetails['paramkey'].trim() && this.parameterDetails['paramkey'].trim() != ' '){
        this.formErrorParameterName = '';
      }else{
        this.formErrorParameterName = 'Parameter name is required';
        this.error = true;
      }

      if(this.parameterDetails && this.parameterDetails['stdunit'] && this.parameterDetails['stdunit'].trim() && this.parameterDetails['stdunit'].trim() != ' '){
        this.formErrorUnit = '';
      }else{
        this.formErrorUnit = 'Standard unit is required';
        this.error = true;
      }

      if(this.addType == 'parameter'){
        if(this.parameterDetails && this.parameterDetails['device_id'] && this.parameterDetails['device_id'].trim() && this.parameterDetails['device_id'].trim() != ' '){
          this.formErrorDeviceIdLinked = '';
        }else{
          this.formErrorDeviceIdLinked = 'Select device';
          this.error = true;
        }
      }

    }



    if(this.error){
      Swal('Error', 'Please provide complete details!', 'error');
    }else{
      this.saveDetails();

    }

  }

  saveDetails(){

    this.addDetailLoader = true;
    this.combineDetails = {};

    this.route  = 'add-industry-new-detail';
    const token = localStorage.getItem('userToken');
    this.combineDetails['user_id'] = this.userName;
    this.combineDetails['type'] = this.addType;

    this.combineDetails['station'] = this.stationDetails;
    this.combineDetails['device'] = this.deviceDetails;
    this.combineDetails['parameter'] = this.parameterDetails;
    this.combineDetails['industry_id'] = this.industryId;

    let data = this.combineDetails;

    this._service.postRequestCreator(data, this.route, token).subscribe(
      
      (response: any) => {
      this.addDetailLoader = false;

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
        if (response.status == 200) {
    this.resetDetails();
    Swal('Success', 'New Details Added successfully', 'success');

  } else if (response.status == 403) {

    const errors = response.error;
    const firstKey = Object.keys(errors)[0];

    Swal('Validation Error', errors[firstKey][0], 'error');

  } else {

    Swal('Oops...', 'Something went wrong!', 'error');
  }


      }



   
  );
  }
}
